<template>
  <v-container>
    <p>
      For the following questions, <i>uptalk</i> is defined as the rising tone
      at the end of declarative sentences. When a speaker uses uptalk, it
      usually sounds like a yes/no question, even though the speaker isn’t
      asking something, but rather making a statement.
    </p>
    <v-form v-model="formValid">
      <v-alert border="left" colored-border color="primary" elevation="2">
        Please rate how often you experience the following:
      </v-alert>
      <div v-for="aq in attitudeQuestionsExperience" :key="aq.key">
        <strong>{{ aq.title }}</strong>
        <v-slider
          v-model="aq.response"
          color="blue"
          track-color="blue"
          hide-details
          min="0"
          max="100"
        >
          <template v-slot:prepend>Always</template>
          <template v-slot:append>Never</template>
        </v-slider>
        <!--<v-select :items="aq.options" single-line v-model="aq.response" item-text="label" item-value="value" label="Please select" dense filled></v-select>-->
        <!-- <v-radio-group
          v-model="aq.response"
          hide-details=""
          class="mt-0 mb-5"
          :rules="requiredRules"
        >
          <v-radio
            v-for="(option, optionIndex) in aq.options"
            :key="optionIndex"
            :label="option.label"
            :value="option.value"
          ></v-radio>
        </v-radio-group> -->
      </div>
      <v-alert border="left" colored-border color="primary" elevation="2" class="mt-5">
        Please indicate the extent to which you agree with the statements below:
      </v-alert>
      <div v-for="aq in attitudeQuestionsAgree" :key="aq.key">
        <strong>{{ aq.title }}</strong>
        <v-select
          :items="aq.options"
          single-line
          v-model="aq.response"
          item-text="label"
          item-value="value"
          label="Please select"
          dense
          filled
        ></v-select>
        <!-- <v-radio-group
          v-model="aq.response"
          hide-details=""
          class="mt-0 mb-5"
          :rules="requiredRules"
        >
          <v-radio
            v-for="(option, optionIndex) in aq.options"
            :key="optionIndex"
            :label="option.label"
            :value="option.value"
          ></v-radio>
        </v-radio-group> -->
      </div>
      <v-divider class="mb-4"></v-divider>
      <strong>Using uptalk may make the person sound...</strong>
      <div class="text-subtitle-1 text--secondary">
        (please complete this sentence with your thoughts about uptalk)
      </div>
      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field
            :rules="requiredRules"
            v-model="uptalk_text1"
            filled
            dense
            placeholder="Your answer here"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            :rules="requiredRules"
            v-model="uptalk_text2"
            filled
            dense
            placeholder="Your answer here"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            :rules="requiredRules"
            v-model="uptalk_text3"
            filled
            dense
            placeholder="Your answer here"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-btn :disabled="!formValid" @click="next" class="mt-4"
        >Next <v-icon>chevron_right</v-icon></v-btn
      >
    </v-form>
  </v-container>
</template>


<script>
import { ref } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import {
  ref as fbRef,
  getDatabase,
  set,
  serverTimestamp,
} from "firebase/database";
export default {
  setup() {
    const requiredRules = [(v) => !!v || "This field is required"];
    const formValid = ref();

    const attitudeQuestionsExperience = ref([
      {
        key: "change",
        title:
          "I'm aware of times that I've changed my voice to sound more professional or knowledgeable",
        response: 50,
      },
      {
        key: "sensitive",
        title:
          "When I speak, I'm sensitive in making sure my listeners are able to follow what I'm saying",
        response: 50,
      },
      {
        key: "uptalk1",
        title: "I have tried not to use uptalk when speaking",
        response: 50,
      },
      {
        key: "favorable",
        title:
          "I've been told some characteristics of my voice are less favorable",
        response: 50,
      },
    ]);
    const attitudeQuestionsAgree = ref([
      {
        key: "professional",
        title:
          "It's important for public image professionals not to use annoying vocal habits",
        options: [
          { label: "Strongly agree", value: "stronglyAgree" },
          { label: "Agree", value: "agree" },
          { label: "Somewhat agree", value: "somewhatAgree" },
          { label: "Somewhat disagree", value: "somewhatDisagree" },
          { label: "Disagree", value: "disagree" },
          { label: "Strongly Disagree", value: "stronglyDisagree" },
        ],
      },
      {
        key: "question",
        title:
          "It's annoying when I hear someone sound like they're asking a question even though they're not",
        options: [
          { label: "Strongly agree", value: "stronglyAgree" },
          { label: "Agree", value: "agree" },
          { label: "Somewhat agree", value: "somewhatAgree" },
          { label: "Somewhat disagree", value: "somewhatDisagree" },
          { label: "Disagree", value: "disagree" },
          { label: "Strongly Disagree", value: "stronglyDisagree" },
        ],
      },
      {
        key: "attention",
        title:
          "Some qualities about voices make it hard for me to consistently pay attention",
        options: [
          { label: "Strongly agree", value: "stronglyAgree" },
          { label: "Agree", value: "agree" },
          { label: "Somewhat agree", value: "somewhatAgree" },
          { label: "Somewhat disagree", value: "somewhatDisagree" },
          { label: "Disagree", value: "disagree" },
          { label: "Strongly Disagree", value: "stronglyDisagree" },
        ],
      },
      {
        key: "pitch",
        title:
          "Voices that are consistently higher pitched are difficult for me to listen to",
        options: [
          { label: "Strongly agree", value: "stronglyAgree" },
          { label: "Agree", value: "agree" },
          { label: "Somewhat agree", value: "somewhatAgree" },
          { label: "Somewhat disagree", value: "somewhatDisagree" },
          { label: "Disagree", value: "disagree" },
          { label: "Strongly Disagree", value: "stronglyDisagree" },
        ],
      },
      {
        key: "publicVoices",
        title:
          "It's important for public voices like podcast hosts not to use uptalk",
        options: [
          { label: "Strongly agree", value: "stronglyAgree" },
          { label: "Agree", value: "agree" },
          { label: "Somewhat agree", value: "somewhatAgree" },
          { label: "Somewhat disagree", value: "somewhatDisagree" },
          { label: "Disagree", value: "disagree" },
          { label: "Strongly Disagree", value: "stronglyDisagree" },
        ],
      },
    ]);

    const uptalk_text1 = ref(null);
    const uptalk_text2 = ref(null);
    const uptalk_text3 = ref(null);

    const next = () => {
      let dataToSave = {
        uptalk_text1: uptalk_text1.value,
        uptalk_text2: uptalk_text2.value,
        uptalk_text3: uptalk_text3.value,
        timestamp: serverTimestamp(),
      };
      for (let aqe of attitudeQuestionsExperience.value) {
        dataToSave[aqe.key] = aqe.response;
      }
      for (let aqa of attitudeQuestionsAgree.value) {
        dataToSave[aqa.key] = aqa.response;
      }
      set(
        fbRef(
          getDatabase(),
          store.state.experimentName + "/attitudeSurvey/" + store.state.pid
        ),
        dataToSave
      );
      store.commit("setLocked", false);
      router.push("/demographics");
    };
    return {
      attitudeQuestionsExperience,
      attitudeQuestionsAgree,
      requiredRules,
      formValid,
      uptalk_text1,
      uptalk_text2,
      uptalk_text3,
      next,
    };
  },
};
</script>